export function SET_WELCOME_BANNER({ commit }, [welcome_banner]) {
    commit('SAVE_WELCOME_BANNER', [welcome_banner])
}